import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { useTokenDisplayDecimals } from '@ui/hooks/useTokenDisplayDecimals';
import { Text } from '@ui/lib/park/ui/text';
import { useTranslation } from 'next-i18next';
import { VStack } from 'styled-system/jsx';

import { useLiqLostP } from '../../../hooks/useLiqLostP';
import { useLiqPrice } from '../../../hooks/useLiqPrice';
import { GenericTradeParams } from '../../../types';
import { headLabelStyle, headValueStyle } from '../styles';

export const LiqPrice = ({ genericTradeParams }: GenericTradeParams) => {
  const { t } = useTranslation();

  const positionLiqPrice = useLiqPrice({ genericTradeParams });
  const positionLiqLostP = useLiqLostP({ genericTradeParams });

  const priceDisplayDecimals = useTokenDisplayDecimals(
    genericTradeParams?.pair.baseSymbol,
    genericTradeParams?.pair.priceDisplayDecimals,
  );

  return (
    <VStack gap={1} justifyContent="center" alignItems="flex-start">
      <Text css={headLabelStyle}>
        {/* {t('common.liq-price-{percentage}', {
          percentage: positionLiqLostP ? positionLiqLostP * 100 : '-',
        })} */}
        {t('common.Liquidation', {
          percentage: positionLiqLostP ? positionLiqLostP * 100 : '-',
        })}
      </Text>
      <AmountUsd
        css={headValueStyle}
        value={positionLiqPrice}
        opts={{
          displayDecimals: priceDisplayDecimals,
        }}
        data-cy="LiqPrice"
        data-cy-value={positionLiqPrice}
      />
    </VStack>
  );
};
